import script from "./ShopProductOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopProductOptions.vue?vue&type=script&setup=true&lang=js"

import "./ShopProductOptions.vue?vue&type=style&index=0&id=84359f9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84359f9e"]])

export default __exports__